import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    DepositLimitWrapper,
    DepositLimitsLink,
    DepositText,
    InfoIconWrapper,
    RemainingLimitWrapper,
} from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/remainingLimit/RemainingLimitNew.style';

interface RemainingLimitType {
    value: string;
    isSignup: boolean;
}

export const RemainingLimitNew = observer('RemainingLimitNew', ({ isSignup, value }: RemainingLimitType) => {
    return (
        <RemainingLimitWrapper data-test='remaining-deposit-limit'>
            <InfoIconWrapper />

            <DepositLimitWrapper>
                <DepositText>You have {value} left on your deposit limit</DepositText>

                <DepositLimitsLink
                    key='limits'
                    to={{ account: 'limits' }}
                    isSignup={isSignup}
                >
                    Review
                </DepositLimitsLink>
            </DepositLimitWrapper>
        </RemainingLimitWrapper>
    );
});
